import { PiFacebookLogoLight, PiInstagramLogo } from "react-icons/pi";
import cyberpackImg from "../Images/CyberPack/Jpgs/Cyberpack-03_v2.png";
import { BiUpArrow } from "react-icons/bi";
import { FaXTwitter } from "react-icons/fa6";
import { AiOutlineLinkedin } from "react-icons/ai";

export const NewFooter = () => {
  const handleScrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Optional: smooth scrolling animation
    });
  };

  return (
    <div
      id="contact-us"
      className="xl:h-[441px] bg-[#09A7E4] flex flex-col items-center justify-centerm"
    >
      <div
        className="size-10 text-xl rounded-[50%] animate-bounce bg-slate-300 fixed bottom-4 right-5 cursor-pointer shadow-2xl z-[50]"
        onClick={() => handleScrollToTop()}
      >
        <BiUpArrow className="mx-auto my-2" />
      </div>
      <div className="w-[85%] text-[#F5F5F5] px-[20px] lg:px-[100px] py-[30px] bg-[#1B1B22] rounded-[30px] h-fit xl:h-[305px] mt-12 flex flex-col">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
          <div className="w-full md:w-fit text-center">
            <img
              src={cyberpackImg}
              alt="cyberpackImg"
              className="w-[187px] mx-auto md:mx-0"
            />
            <div className="text-[#F5F5F5] font-normal text-base leading-[100%] tracking-[0%] mt-7 mb-[30px] text-left">
              CyberPack was founded in 2014 and has grown to over 50 staff with
              offices in United Kingdom UK and Nigeria. We service more than 50
              medium and large organisations and build long term partnerships
              with our clients.
            </div>
          </div>
          <div className="leading-[100%] tracking-[0%] md:pl-10 text-center md:text-left">
            <div className="font-semibold text-xl leading-[100%] tracking-[0%]">
              Contact us
            </div>
            <div className="flex md:flex-col xl:flex-row items-start justify-between mt-7">
              <div className="text-left">
                <div className="">Nigeria</div>
                <div className="mt-2">+234 904 933 8341</div>
                <br />

                <div className="mt-2">info@cyberpackhq.com</div>
              </div>
              <div className="text-left md:mt-5 xl:mt-0 xl:ml-5">
                <div className="">United Kingdom</div>
                <div className="mt-2">+447366355226</div>
              </div>
            </div>
          </div>
          <div className="leading-[100%] tracking-[0%] md:pl-16 text-center md:text-left my-4 md:my-2 lg:my-0">
            <div className="font-semibold text-xl leading-[100%] tracking-[0%]">
              Navigations
            </div>

            <a href="#our-work">
              <div className="mt-7">Our work</div>
            </a>
            <a href="#our-services">
              <div className="mt-2">Our services</div>
            </a>
            <a href="#careers">
              <div className="mt-2">Careers</div>
            </a>
            <a href="#contact-us">
              <div className="mt-2">Contact us</div>
            </a>
          </div>
        </div>
        <hr />
        <div className="flex items-center w-fit mx-auto gap-x-4 mt-8">
          <a
            href="https://web.facebook.com/profile.php?id=61586850488580"
            target="_blank"
            rel="noreferrer"
          >
            <PiFacebookLogoLight className="text-xl" />
          </a>
          <a
            href="https://www.instagram.com/cyber_packhq/"
            target="_blank"
            rel="noreferrer"
          >
            <PiInstagramLogo className="text-xl" />
          </a>
          <a
            href="https://x.com/cyberpackh8102"
            target="_blank"
            rel="noreferrer"
          >
            <FaXTwitter className="text-xl" />
          </a>
          <a href="https://www.youtube.com/" target="_blank" rel="noreferrer">
            <AiOutlineLinkedin className="text-xl" />
          </a>
        </div>
      </div>
      <div className="text-white text-center px-[3vw] md:px-0 font-normal text-base leading-[100%] tracking-[0%] mt-8 mb-8 xl:mb-0">
        Cyberpack Technologies © {new Date().getFullYear()}. All Rights
        Reserved.
      </div>
    </div>
  );
};
